// FloatingOrb.jsx
import React from 'react';
import styles from './floatingOrb.module.css';

export default function FloatingOrb({ 
  size = 200, 
  duration = 20, 
  color = "cyan", 
  position = "left"   // ← new prop
}) {
  return (
    <div 
      className={`${styles.floatingOrb} ${styles[color]} ${styles[position]}`}
      style={{ 
        "--size": `${size}px`, 
        "--duration": `${duration}s` 
      }}
    />
  );
}